/*
export function someGetter (state) {
}
 */

export const sideMenuOpen = (state)=>  {
  return state.isSideMenuOpen
}
